module.exports = __webpack_public_path__ + "static/media/proof-of-residence.f1b8a946.svg";